import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import { withRouter } from 'react-router-dom'

import { HOME_PATH } from '../../../configs'

/**
 * "Package creation" — the secondary action beside "New QCS organisation".
 *
 * Opens the full-page Package builder (not a modal), where packages are created
 * and edited.
 */
const styles = () => ({
  item: {
    height: 48,
    padding: '0 20px',
    boxSizing: 'border-box',
    background: 'var(--careco-surface, #fff)',
    border: '1px solid var(--careco-primary)',
    borderRadius: 'var(--careco-rounded-sm)',
    fontFamily: 'var(--careco-font)',
    fontSize: 14,
    fontWeight: 600,
    color: 'var(--careco-primary)',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background 140ms ease',
    '&:hover': { background: 'var(--careco-primary-light)' },
    '&:focus-visible': {
      outline: '2px solid var(--careco-primary)',
      outlineOffset: 2,
    },
  },
  itemText: {
    margin: 0,
  },
})

// Lucide `package`, drawn inline (the repo ships no lucide package).
const PackageGlyph = () => (
  <svg width={16} height={16} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    {[
      'm7.5 4.27 9 5.15',
      'M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z',
      'm3.3 7 8.7 5 8.7-5',
      'M12 22V12',
    ].map((d, i) => (
      <path
        key={i}
        d={d}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ))}
  </svg>
)

const PackageCreationButton = ({ classes, history }) => (
  <button
    type="button"
    className={classes.item}
    onClick={() => history.push(`${HOME_PATH}/packages`)}
    data-autotest={'package-creation-button'}>
    <PackageGlyph />
    <p className={classes.itemText}>Package creation</p>
  </button>
)

PackageCreationButton.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object,
}

export default withRouter(withStyles(styles)(PackageCreationButton))
